import { NgModule } from '@angular/core';
import { HisProblemCaseSharedModule } from './his-problem-case-shared.module';

/**
 * CoreModule for problem case (a.k.a. Kommunikationstool).
 */
@NgModule({
    imports: [HisProblemCaseSharedModule],
    declarations: [],
    exports: [HisProblemCaseSharedModule]
})
export class HisProblemCaseCoreModule {}
